import { makeStyles } from '@material-ui/core/styles';

export const useSliderStyles = makeStyles({
	root: {
		width: 220,
		height: 3,
		paddingTop: 20
	},
	active: {},
	track: {
		height: 2,
		borderRadius: 1,
		color: 'currentColor'
	},
	rail: {
		color: '#d8d8d8',
		opacity: 1,
		height: 2,
		borderRadius: 1
	},
	mark: {
		backgroundColor: '#d8d8d8'
	},
	markActive: {
		opacity: 1,
		backgroundColor: 'currentColor'
	}
});

export const useStyles = makeStyles(theme => ({
	rangeSlidersContent: {
		padding: `${theme.spacing(2)}px
                  ${theme.spacing(7)}px
                  4px
                  0px`
	},
	rangeSlidersList: {
		padding: `${theme.spacing(1)}px
                  ${theme.spacing(3)}px
                  4px
                  ${theme.spacing(2)}px`,
		width: 220
	}
}));
